import { ref } from "vue";

const DEFAULT_DURATION = 5000;

let nextId = 0;
export const adminToasts = ref([]);

export function showAdminToast(message, type = "success", duration = DEFAULT_DURATION) {
  if (!message) return;

  const id = ++nextId;
  adminToasts.value.push({
    id,
    message,
    type,
    duration: duration > 0 ? duration : 0,
  });

  if (duration > 0) {
    setTimeout(() => dismissAdminToast(id), duration);
  }
}

export function dismissAdminToast(id) {
  adminToasts.value = adminToasts.value.filter((toast) => toast.id !== id);
}

export function consumeAdminFlash() {
  const flash = sessionStorage.getItem("adminFlash");
  if (!flash) return;

  try {
    const { message, type } = JSON.parse(flash);
    if (message) showAdminToast(message, type || "success");
  } catch {
    /* ignore invalid flash */
  }

  sessionStorage.removeItem("adminFlash");
}
